module.exports = __webpack_public_path__ + "assets/login-logo-icon.38534e5a790f3c6946f7aef526c2fba2.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/login-logo-icon.png
// module id = 634
// module chunks = 0